import { render } from "./TabInfo.vue?vue&type=template&id=057386b8"
import script from "./TabInfo.vue?vue&type=script&lang=js"
export * from "./TabInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__